module.exports = __webpack_public_path__ + "static/media/DQLogo.7131dd42.png";